import React, { useEffect } from 'react'
import { useState } from 'react'
import PropTypes from 'prop-types'
import ModalContainer from '../../../ModalContainer/ModalContainer'

// icon
import ArrowIcon from 'components/Icons/ArrowIcon'
import ClockIcon from 'components/Icons/ClockIcon'
import FlagIcon from 'components/Icons/FlagIcon'
import XIcon from 'components/Icons/XIcon'
import TaskDetailModalTabContent from './TaskDetailModalTabContent'
import moment from 'moment'
import DefaultImage from 'components/Common/DefaultImage'
import { useGetTaskApiQuery } from 'redux/api/task_api'
import Spinner from 'components/Common/Spinner'
import ProgressDropDown from 'components/Common/ProgressDropDown'
import TaskAttachment from 'components/Page/Attachments/taskAttachment'
import { useRole } from 'hooks/useRole'
import { useLazyGetLogByTaskIdQuery } from 'redux/api/log_api'
import ListZeroPage from 'components/Common/ListZeroPage'
import LowPriorityIcon from 'components/Icons/tasks/lowPriority'
import MediumPriorityIcon from 'components/Icons/tasks/mediumPriority'
import ImportantPriorityIcon from 'components/Icons/tasks/importantPriority'
import UrgentPriorityIcon from 'components/Icons/tasks/urgentPriority'
import TaskDetailNoteClientModal from './TaskDetailModal/TaskDetailNoteClientModal'
import TextEditor from 'components/Common/TextEditor'

function TaskDetailModal({
	handler,
	data,
	updateList,
	position = '',
	isSubtask = false
}) {
	const { data: task, isLoading } = useGetTaskApiQuery({ taskId: data.id })
	let [getLogs, { data: logsData }] = useLazyGetLogByTaskIdQuery()
	const isClient = useRole('Client')

	const taskPriorities = [
		{ id: 1, label: 'low', icon: <LowPriorityIcon /> },
		{ id: 2, label: 'medium', icon: <MediumPriorityIcon /> },
		{ id: 3, label: 'important', icon: <ImportantPriorityIcon /> },
		{ id: 4, label: 'urgent', icon: <UrgentPriorityIcon /> }
	]

	const [tabActive, setTabActive] = useState('viewTask')

	return (
		<ModalContainer maxHeight={true} setShowModal={handler}>
			<section className='team w-[800px]'>
				<div className='flex justify-between items-start m-5'>
					<div className='bg-gray-300 rounded-[10px] px-3 flex flex-col justify-center items-start gap-4 w-[98%] h-[50px]'>
						<h6 className='font-medium text-lg'>{task?.name}</h6>
					</div>
					<button onClick={() => handler()} className='ml-4'>
						<XIcon width={15} hight={15} color='#212121' />
					</button>
				</div>

				<ul
					className={`grid grid-cols-2 border-b border-solid border-gray-200`}>
					<li
						className={`flex justify-center py-3 border-b-4 border-transparent ${
							tabActive === 'viewTask' && 'border-solid !border-primaryBlue'
						}`}>
						<button
							onClick={() => setTabActive('viewTask')}
							className={`text-base font-bold ${
								tabActive === 'viewTask'
									? 'text-primaryBlue'
									: 'text-[#212121] text-opacity-50'
							}`}>
							View Task
						</button>
					</li>
					{isClient && (
						<li
							className={`flex justify-center py-3 border-b-4 border-transparent ${
								tabActive === 'taskNotes' && 'border-solid !border-primaryBlue'
							}`}>
							<button
								onClick={() => setTabActive('taskNotes')}
								className={`text-base font-bold ${
									tabActive === 'taskNotes'
										? 'text-primaryBlue'
										: 'text-[#212121] text-opacity-50'
								}`}>
								Task Notes
							</button>
						</li>
					)}
					{!isClient && (
						<li
							className={`flex justify-center py-3 border-b-4 border-transparent ${
								tabActive === 'editTask' && 'border-solid !border-primaryBlue'
							}`}>
							<button
								onClick={() => setTabActive('editTask')}
								className={`text-base font-bold ${
									tabActive === 'editTask'
										? 'text-primaryBlue'
										: 'text-[#212121] text-opacity-50'
								}`}>
								Edit Task
							</button>
						</li>
					)}
				</ul>
				{tabActive === 'viewTask' ? (
					<div className='px-8 pt-[28px] pb-5'>
						<div className='flex flex-col gap-[10px] h-[160px]'>
							<div className='bg-white px-5 py-4 text-sm border border-gray-330 rounded-[10px]'>
								<div className='flex items-center mb-5 justify-between'>
									<div className='flex gap-1 items-center'>
										{task?.teams?.map(item => (
											<DefaultImage
												bgColor={item?.background_color}
												mainColor={item?.foreground_color}
												name={item?.first_name + ' ' + item?.last_name}
												size={40}
												src={item?.avatar}
											/>
										))}
									</div>
								</div>
								<div className='flex items-center gap-[5px]'>
									{!isClient && task && (
										<ProgressDropDown
											bigSize
											parentDetail={data}
											data={task?.progress}
											position='searchResult'
										/>
									)}
									<div className='bg-gray-300 rounded-[10px] px-4 flex flex-col justify-center items-center gap-4 h-[71px]'>
										<span className='flex items-center gap-1.5 text-xs text-gray-700 text-opacity-80 font-light'>
											Status
										</span>
										<span className='font-medium -mt-3 text-opacity-100 text-sm text-gray-700 flex items-center'>
											{task?.progress.name}
										</span>
									</div>
									<div className='bg-gray-300 rounded-[10px] px-3 flex flex-col justify-center items-center gap-4 h-[71px]'>
										<span className='flex items-center gap-1.5 text-xs text-gray-700 text-opacity-80 font-light'>
											<FlagIcon />
											Priority
										</span>
										<span className='font-medium -mt-3 text-opacity-100 text-sm text-gray-700 flex items-center'>
											{task?.priority}{' '}
											{task?.priority &&
												taskPriorities.filter(
													item => item.label === task?.priority
												)[0].icon}
										</span>
									</div>
									<div className='bg-gray-300 rounded-[10px] px-4 flex flex-col justify-center items-center gap-4 h-[71px]'>
										<span className='flex items-center gap-1.5 text-xs text-gray-700 text-opacity-80 font-light'>
											<ClockIcon />
											Due Time
										</span>
										<span className='font-medium -mt-3 text-opacity-100 text-sm text-gray-700'>
											{moment(task?.due_date).format('YYYY-MM-DD')}
										</span>
									</div>
									<div className='bg-gray-300 rounded-[10px] px-1 flex items-center gap-4 h-[71px]'>
										<div className='grid text-sm text-gray-700 text-right font-[300] w-full'>
											<span className='text-opacity-80 font-[300] text-xs'>
												Budgeted Hours
											</span>
											<span className='font-medium '> {task?.time_budget}</span>
										</div>
									</div>
									<div className='bg-gray-300 rounded-[10px] px-3 flex flex-col justify-center items-center gap-1 h-[71px]'>
										<div className='text-opacity-80 font-[300] text-xs'>
											Created at
										</div>
										<span>{moment(task?.created_at).format('YYYY-MM-DD')}</span>
									</div>
								</div>
							</div>
							<div className='flex flex-row gap-[10px] h-[30px] mt-3'>
								<span className='text-opacity-80 font-[300] text-xs'>
									Description
								</span>
							</div>
							<div className='flex flex-row gap-[10px] h-[300px]'>
								{!task?.description || task?.description?.includes('<') ? (
									<div
										dangerouslySetInnerHTML={{
											__html: `${task?.description ?? ''}`
										}}
										className='bg-white p-4 flex-1 text-sm border border-gray-330 rounded-[10px] font-light list-disc text-gray-700 text-opacity-80 overflow-h-[300px] overflow-auto'></div>
								) : (
									<p className='bg-white p-4 flex-1 text-sm border border-gray-330 rounded-[10px] font-light text-gray-700 text-opacity-80 overflow-h-[300px] overflow-auto'>
										{task?.description ?? ''}
									</p>
								)}
							</div>
						</div>
					</div>
				) : tabActive === 'taskNotes' ? (
					<div className='bg-white w-[800px] h-full'>
						<div className='px-8 pt-5 pb-8 flex gap-[10px]'>
							<TaskDetailNoteClientModal parentData={data} />
						</div>
					</div>
				) : (
					<div className='bg-white w-[800px] h-full'>
						<div className='px-8 pt-5 pb-8 flex gap-[10px]'>
							<TaskDetailModalTabContent
								isSubtask={isSubtask}
								modalHandler={handler}
								updateList={updateList}
								data={task}
							/>
							{/* <TaskAttachment
								data={position === '' ? task : data}
								position={position}
							/> */}
						</div>
					</div>
				)}
			</section>
		</ModalContainer>
	)
}

ModalContainer.propTypes = {
	handler: PropTypes.func.isRequired
}
ModalContainer.defaultProps = {
	handler: () => {}
}

export default TaskDetailModal
